export const DimensionOptions = {
	Options: 'dim_options',
	BreakoutGroups: 'dim_breakout_groups',
	RemoveDimension: 'remove_dimension',
	EnableDrilldown: 'enable_drilldown',
};
